import { cn } from '@/src/utils/styles'

export interface SkeletonProps {
  className?: string
  delay?: string
}

export function Skeleton({ className, delay }: SkeletonProps) {
  return (
    <div
      className={cn(
        'animate-[shine_1000ms_infinite] rounded-[8px] ease-in-out bg-gradient-to-r from-30% from-border1 via-tertiary to-70% to-border1 bg-[length:300%_100%] opacity-30',
        className,
      )}
      style={{
        animationDelay: delay,
      }}
    />
  )
}
